/*! @azure/msal-common v14.7.1 2024-02-17 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.7.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
